import Vue from 'vue';
import Router from 'vue-router';
import RouterWatcher from './watcher';
import routes from './routes';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const whitelist = ['Auth', 'Logout'];

  if (whitelist.includes(to.name)) {
    return next();
  }

  return next();
});

RouterWatcher(router, store);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js